import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { DeptUserCascader as LocalDeptUserCascader } from '../../components/DeptUser/Cascader'

export const DeptUserCascader = connect(
  LocalDeptUserCascader,
  mapReadPretty(LocalDeptUserCascader, {
    disabled: true
  } as any)
)
